import React, { useRef, useEffect, useState } from "react";

import { loadDashboardData } from "../api/apiService";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Link } from 'react-router-dom';
import { useToken } from "../components/TokenContext";
 
const IncomeCard = () => {
  const [loading, setLoading] = useState(false);
 const [dashboardData, setDashboardData] = useState(null);
  const [referralLink, setReferralLink] = useState(null);
  const { jwtToken, fetchToken } = useToken();
const [timeLeft, setTimeLeft] = useState("");
const countdownRef = useRef(null);
  const fetchDashboard = async () => {
    setLoading(true);
    try {
      const currentToken = jwtToken || (await fetchToken());
      if (!currentToken) return;
      const loginToken = localStorage.getItem("LoginToken") || currentToken;
      const data = await loadDashboardData(currentToken, loginToken);
      setDashboardData(data);
    }
    catch (err) {
      setDashboardData(null);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [jwtToken]);

  return (
    <div className="income-elegant-wrapper">
       <div className="income-elegant-row row">
    
    <div className="col mb-4">
     <Link to="/my-earnings/direct-bonus" className="text-decoration-none">
  <div className="income-elegant-card">
    <div className="icon soft-blue">
      <i className="fa-solid fa-coins"></i>
    </div>

    <div className="content">
      <h3>
        <i className="fa-solid fa-dollar-sign"></i>
        {dashboardData?.Dashboard?.DIRECTINCOME}
      </h3>
      <span>Direct Referral</span>
    </div>
  </div>
</Link>
    </div>


    <div className="col mb-4">
        <Link to="/my-earnings/roi-bonus" className="text-decoration-none">
    <div className="income-elegant-card">
          <div className="icon soft-purple">
            <i className="fa-solid fa-gem"></i>
          </div>
          <div className="content">
            <h3> <i class="fa-solid fa-dollar-sign"></i> {dashboardData?.Dashboard?.ROIINCOME}</h3>
            <span>ROI income</span>
          </div>
        </div>
    </Link>
    </div>
    
    <div className="col mb-4">
        <Link to="/my-earnings/level-bonus" className="text-decoration-none">
   <div className="income-elegant-card">
          <div className="icon soft-gold">
            <i className="fa-solid fa-bolt"></i>
          </div>
          <div className="content">
            <h3><i class="fa-solid fa-dollar-sign"></i> {dashboardData?.Dashboard?.LEVELINCOME}</h3>
            <span>ROI Level Income</span>
          </div>          
        </div>
        </Link>
    </div>
    

 

    <div className="col mb-4">
         <Link to="/my-earnings/weekly-bonus" className="text-decoration-none">
         <div className="income-elegant-card">

          <div className="icon soft-rose">
            <i className="fa-solid fa-crown"></i>
          </div>
          <div className="content">
            <h3><i class="fa-solid fa-dollar-sign"></i> {dashboardData?.Dashboard?.WEEKLYBONUS}</h3>
            <span>Weekly Bonus</span>
          </div>
          
          {/* <Link hrefLang='#' className='link-report'><i class="fa-solid fa-arrow-right"></i></Link> */}
        </div>  
        </Link>
      </div>
      </div>


       <div className="income-elegant-row row">
  <div className="col mb-4">
         <div className="income-elegant-card">

          <div className="icon soft-rose">
            <i className="fa-solid fa-crown"></i>
          </div>
          <div className="content">
            <h3><i class="fa-solid fa-dollar-sign"></i> {dashboardData?.Dashboard?.TOTALINCOME}</h3>
            <span>Total Income</span>
          </div>
          
          {/* <Link hrefLang='#' className='link-report'><i class="fa-solid fa-arrow-right"></i></Link> */}
        </div>  
      </div>

        <div className="col mb-4">
         <Link to="/my-affiliate/all" className="text-decoration-none">
         <div className="income-elegant-card">

          <div className="icon soft-rose">
            <i className="fa-solid fa-crown"></i>
          </div>
          <div className="content">
            <h3>{dashboardData?.Dashboard?.NOOFTEAM}</h3>
            <span>Total Team Members</span>
          </div>
          
          {/* <Link hrefLang='#' className='link-report'><i class="fa-solid fa-arrow-right"></i></Link> */}
        </div>  
        </Link>
      </div>

        <div className="col mb-4">
         <Link to="/my-affiliate/all" className="text-decoration-none">
         <div className="income-elegant-card">

          <div className="icon soft-rose">
            <i className="fa-solid fa-crown"></i>
          </div>
          <div className="content">
            <h3><i class="fa-solid fa-dollar-sign"></i> {dashboardData?.Dashboard?.TEAMBUSINESS}</h3>
            <span>Total Team Business</span>
          </div>
          
          {/* <Link hrefLang='#' className='link-report'><i class="fa-solid fa-arrow-right"></i></Link> */}
        </div>  
        </Link>
      </div>

        <div className="col mb-4">
       
         <div className="income-elegant-card">

          <div className="icon soft-rose">
            <i className="fa-solid fa-crown"></i>
          </div>
          <div className="content">
            <h3><i class="fa-solid fa-dollar-sign"></i> {dashboardData?.Dashboard?.AVAILABLEBONUSWALLET}</h3>
            <span>Fund Wallet Balance</span>
          </div>
          
          {/* <Link hrefLang='#' className='link-report'><i class="fa-solid fa-arrow-right"></i></Link> */}
        </div>  

      </div>

</div>
    </div>

  );
};

export default IncomeCard;
